import { AlertCircle, CheckCircle2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSatDownloadJobsOptional } from "@/lib/satDownloadJobs";

export default function SatDownloadCompletionBanner() {
  const ctx = useSatDownloadJobsOptional();
  const notices = ctx?.notices ?? [];
  if (!notices.length) return null;

  return (
    <div
      className="shrink-0 border-b border-slate-200 bg-white px-4 py-2 sm:px-6 space-y-2"
      data-testid="sat-download-completion-banners"
    >
      {notices.map((n) => {
        const isSuccess = n.variant === "success";
        return (
          <div
            key={n.id}
            className={`flex items-start gap-3 rounded-sm border px-3 py-2.5 text-xs leading-relaxed ${
              isSuccess
                ? "border-emerald-200 bg-emerald-50 text-emerald-950"
                : "border-amber-200 bg-amber-50 text-amber-950"
            }`}
            data-testid={`sat-download-notice-${n.variant}`}
          >
            {isSuccess ? (
              <CheckCircle2 className="h-4 w-4 shrink-0 text-emerald-700 mt-0.5" />
            ) : (
              <AlertCircle className="h-4 w-4 shrink-0 text-amber-700 mt-0.5" />
            )}
            <div className="flex-1 min-w-0">
              <p className="m-0 font-semibold">{n.title}</p>
              <p className="m-0 mt-0.5">{n.body}</p>
            </div>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="h-7 w-7 shrink-0 opacity-70 hover:opacity-100"
              onClick={() => ctx?.dismissNotice(n.id)}
              aria-label="Cerrar aviso"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        );
      })}
    </div>
  );
}
